import { useState, useMemo } from "react";
import { ExclamationTriangleIcon, CopyIcon } from "../../../assets/icons";
import FormField from "../../FormField/FormField";
import UploadArchivioPdf from "../UploadArchivioPdf/UploadArchivioPdf";
import Georeferenziazioni from "../../Georeferenziazioni/Georeferenziazioni";
import GroupsFormField from "../../GroupsFormField/GroupsFormField";
import TipologiaDocumentiArchivio from "../../../assets/json/tipologia-documenti-archivio.json";
import CustomSelect from "../../Common/CustomSelect/CustomSelect";

const ArchivioDetailForm = ({
  showIssues,
  issues,
  disabled = false,
  formData,
  archivioStructure,
  copyToClipboard,
  handleFormDataChange,
}) => {

  const [tipoDocumentoKey, setTipoDocumentoKey] = useState(0);

  const handleSelectChange = (name, option) => {
    handleFormDataChange("categoria", option.value);
    setTipoDocumentoKey((prevKey) => prevKey + 1);
  };
  const customOptions = useMemo(() => {
    return TipologiaDocumentiArchivio.map((item) => ({
      label: item.tipo,
      value: item.tipo,
    }));
  }, []);

  console.log("TipologiaDocumentiArchivio", TipologiaDocumentiArchivio);
  console.log("formData", formData);
  console.log("customOptions", customOptions);

  return (
    <div className="content-wrapper">
      <div className="issue-container">
        {showIssues &&
          issues.map((issue, index) => {
            return (
              <div key={index} className="issue">
                <p className="issue-icon">
                  <ExclamationTriangleIcon />{" "}
                </p>
                {issue}
              </div>
            );
          })}
      </div>
      <div className="blocks-container">
          <div className="form-block" id="generalità">
            <p className="section-title">GENERALITÀ</p>
            <div className="reperto-id-header">
              <p className="reperto-id-text">ID fascicolo</p>
              <p
                className="copy-text"
                onClick={() => copyToClipboard(formData?.id)}
              >
                {formData?.id}
                <CopyIcon />
              </p>
            </div>
            <GroupsFormField
            groups={formData["groups"]}
            onChange={(newValue) => handleFormDataChange("groups", newValue)}
            edit={!disabled}
          />
            {/*
            <FormField
              fieldStructure={archivioStructure["comune"]}
              value={formData["comune"]}
              onChange={(newValue) => handleFormDataChange("comune", newValue)}
              disabled={disabled}
            />
            */}
            <FormField
              fieldStructure={archivioStructure["fascicolo"]}
              value={formData["fascicolo"]}
              onChange={(newValue) =>
                handleFormDataChange("fascicolo", newValue)
              }
              disabled={disabled}
            />
            <FormField
              fieldStructure={archivioStructure["posizione"]}
              value={formData["posizione"]}
              onChange={(newValue) =>
                handleFormDataChange("posizione", newValue)
              }
              disabled={disabled}
            />
            <FormField
              fieldStructure={archivioStructure["protocollo"]}
              value={formData["protocollo"]}
              onChange={(newValue) =>
                handleFormDataChange("protocollo", newValue)
              }
              disabled={disabled}
            />
            <FormField
              fieldStructure={archivioStructure["anno"]}
              value={formData["anno"]}
              onChange={(newValue) => handleFormDataChange("anno", newValue)}
              disabled={disabled}
            />
          </div>

          {/* georeferenziazioni */}
          <div className="form-block" id="georeferenziazioni">
            <div className="form-block-header">
              <p className="form-block-header-title">Riferimenti GIS</p>
            </div>
            <Georeferenziazioni
              georeferenziazioni={formData["georeferenziazioni"]}
              onChange={(newValue) => handleFormDataChange("georeferenziazioni", newValue)}
              edit={!disabled}
            />
        </div>
          {/* categoria */}
          <div className="form-block" id="categoria">
            <div className="form-block-header">
              <p className="form-block-header-title">Descrizione</p>
            </div>
            <CustomSelect
              key={`tipo-${tipoDocumentoKey}`}
              options={customOptions}
              initValue={{
                label: formData["categoria"],
                value: formData["categoria"],
              }}
              name="categoria"
              label={"Tipo documento"}
              disabled={disabled}
              placeholder="Seleziona tipo documento"
              onChange={handleSelectChange}
            />
            <FormField
              fieldStructure={archivioStructure["descCategoria"]}
              value={formData["descCategoria"]}
              onChange={(newValue) =>
                handleFormDataChange("descCategoria", newValue)
              }
              disabled={disabled}
            />
          </div>
          {/* upload pdf */}
          <UploadArchivioPdf
            idPdfArchivio={formData?.allegati}
            disabled={disabled}
            onChange={(newValue) => {
              handleFormDataChange("allegati", newValue)
            }}
          />
        </div>
    </div>
  );
};

export default ArchivioDetailForm;
